module.exports = __webpack_public_path__ + "static/media/001.ef265bb4.jpg";